import type { ChatHandlerConfig } from './types';

const defaults: ChatHandlerConfig = {
  buildWelcomeMarkup: () => '',
  nextLocalId: (prefix = 'tmp') => `${prefix}-${Date.now()}`,
  renderAttachmentLabels: () => '',
  autoResize: () => {},
  saveQuickMessage: () => false,
  hasQuickMessage: () => false,
  rebuildCurrentSession: () => {},
  truncateSessionForEdit: () => {},
};

let handlers: ChatHandlerConfig = { ...defaults };

export function configureChatHandlers(nextHandlers: ChatHandlerConfig): void {
  handlers = { ...defaults, ...nextHandlers };
}

export function buildWelcomeMarkup(agent: string): string {
  return handlers.buildWelcomeMarkup(agent);
}

export function nextLocalId(prefix?: string): string {
  return handlers.nextLocalId(prefix);
}

export function renderAttachmentLabels(attachments: unknown[], options?: unknown): string {
  return handlers.renderAttachmentLabels(attachments, options);
}

export function autoResize(): void {
  handlers.autoResize();
}

export function saveQuickMessage(text: string): boolean {
  return handlers.saveQuickMessage(text);
}

export function hasQuickMessage(text: string): boolean {
  return handlers.hasQuickMessage(text);
}

export function rebuildCurrentSession(anchor?: { clientMessageId?: string; timestamp?: string }): void {
  handlers.rebuildCurrentSession(anchor);
}

export function truncateSessionForEdit(anchor: { clientMessageId?: string; timestamp?: string }): void {
  handlers.truncateSessionForEdit(anchor);
}
